// // src/pages/Reports/tables/BajajDebitTable.js
// import React, { useState, useEffect } from "react"
// import { getCombinedTransactionReport } from "../../../helpers/api_helper"

// const BajajDebitTable = ({ filters }) => {
//   const [expandedRows, setExpandedRows] = useState({})
//   const [tableData, setTableData] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [totalRecords, setTotalRecords] = useState(0)
//   const [pageIndex, setPageIndex] = useState(0)
//   const [pageSize, setPageSize] = useState(10)

//   const fetchData = async (
//     newPageIndex = pageIndex,
//     newPageSize = pageSize
//   ) => {
//     setLoading(true)
//     const offset = newPageIndex * newPageSize

//     try {
//       const res = await getCombinedTransactionReport({
//         limit: newPageSize,
//         offset,
//         startDate: filters?.startDate || null,
//         endDate: filters?.endDate || null,
//         mobileNumber:
//           filters?.mobileNumbers?.length > 0 ? filters.mobileNumbers : null,
//       })

//       console.log("Bajaj Debit API Response:", res)

//       if (!res.success || !res.data) {
//         setTableData([])
//         setTotalRecords(0)
//         return
//       }

//       setTotalRecords(res.totalRecords || 0)

//       let rows = []

//       Object.entries(res.data || {}).forEach(([date, mobiles]) => {
//         Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
//           const openingClosing = categories.opening_closing || {}

//           const bajaj599 = categories.bajaj_599_debit?.total?.amount || 0
//           const bajaj699 = categories.bajaj_699_debit?.total?.amount || 0
//           const bajajOther = categories.bajaj_other_debit?.total?.amount || 0
//           const bajajDebitTotal = bajaj599 + bajaj699 + bajajOther

//           const otherDebit = categories.other_debit?.total?.amount || 0

//           const bajaj599Details = categories.bajaj_599_debit?.details || []
//           const bajaj699Details = categories.bajaj_699_debit?.details || []
//           const bajajOtherDetails = categories.bajaj_other_debit?.details || []
//           const otherDebitDetails = categories.other_debit?.details || []

//           const subTransactions = [
//             ...bajaj599Details.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Bajaj Debit 599",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//             ...bajaj699Details.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Bajaj Debit 699",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//             ...bajajOtherDetails.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Bajaj Other Debit",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//             ...otherDebitDetails.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Other Debit",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//           ]

//           rows.push({
//             id: `${date}-${mobile}`,
//             date: date.trim(),
//             mobile: mobile.trim(),
//             opening: openingClosing.opening || 0,
//             closing: openingClosing.closing || 0,
//             bajajDebit: bajajDebitTotal,
//             otherDebit: otherDebit,
//             subTransactions,
//           })
//         })
//       })

//       rows.sort((a, b) => new Date(b.date) - new Date(a.date))

//       setTableData(rows)
//       setPageIndex(newPageIndex)
//       setPageSize(newPageSize)
//     } catch (err) {
//       console.error("Bajaj Debit fetch error:", err)
//       setTableData([])
//       setTotalRecords(0)
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchData(0, pageSize)
//   }, [filters, pageSize])

//   const formatCurrency = val => `₹${Number(val || 0).toLocaleString("en-IN")}`

//   const toggleExpand = id => {
//     setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }))
//   }

//   const renderSubTable = (subTransactions = []) => (
//     <div className="bg-light p-4 border-top">
//       <h6 className="mb-3 fw-semibold">Transaction Details</h6>
//       <div className="table-responsive">
//         <table className="table table-bordered table-sm mb-0">
//           <thead className="table-light">
//             <tr>
//               <th>Date Time</th>
//               <th>Type</th>
//               <th>Amount</th>
//               <th>Transaction ID</th>
//             </tr>
//           </thead>
//           <tbody>
//             {subTransactions.length > 0 ? (
//               subTransactions.map((sub, idx) => (
//                 <tr key={idx}>
//                   <td>{sub.dateTime || "N/A"}</td>
//                   <td>{sub.type || "N/A"}</td>
//                   <td>{formatCurrency(sub.amount)}</td>
//                   <td>{sub.transactionId || "N/A"}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={4} className="text-center text-muted py-3">
//                   No detailed debit transactions available in this report
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   )

//   // ────────────── Export CSV with Main + Sub-transactions ──────────────
//   const handleExportCSV = () => {
//     if (loading || tableData.length === 0) {
//       alert("No data available to export right now.")
//       return
//     }

//     const dateStr = new Date().toISOString().split("T")[0]
//     const filename = `bajaj-debit-report_${dateStr}.csv`

//     const headers = [
//       "Date (Main)",
//       "Mobile",
//       "Opening",
//       "Closing",
//       "Bajaj Debit (Total)",
//       "Other Debit (Total)",
//       "Transaction Date Time",
//       "Type",
//       "Amount",
//       "Transaction ID",
//     ]

//     const csvRows = [headers.join(",")]

//     tableData.forEach(row => {
//       if (row.subTransactions.length === 0) {
//         // No sub-transactions → only main row
//         const mainValues = [
//           `"${(row.date || "").replace(/"/g, '""')}"`,
//           `"${(row.mobile || "").replace(/"/g, '""')}"`,
//           row.opening || 0,
//           row.closing || 0,
//           row.bajajDebit || 0,
//           row.otherDebit || 0,
//           "",
//           "",
//           "",
//           "",
//         ]
//         csvRows.push(mainValues.join(","))
//       } else {
//         // Main row repeat for each sub-transaction
//         row.subTransactions.forEach(sub => {
//           const values = [
//             `"${(row.date || "").replace(/"/g, '""')}"`,
//             `"${(row.mobile || "").replace(/"/g, '""')}"`,
//             row.opening || 0,
//             row.closing || 0,
//             row.bajajDebit || 0,
//             row.otherDebit || 0,
//             `"${(sub.dateTime || "").replace(/"/g, '""')}"`,
//             `"${(sub.type || "").replace(/"/g, '""')}"`,
//             sub.amount || 0,
//             `"${(sub.transactionId || "").replace(/"/g, '""')}"`,
//           ]
//           csvRows.push(values.join(","))
//         })
//       }

//       // Blank line between different main rows/groups
//       csvRows.push(",")
//     })

//     const csvContent = csvRows.join("\n")

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement("a")
//     link.href = url
//     link.setAttribute("download", filename)
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
//   }

//   const totalPages = Math.ceil(totalRecords / pageSize)
//   const canGoPrev = pageIndex > 0
//   const canGoNext = pageIndex < totalPages - 1

//   const getPageNumbers = () => {
//     const pages = []
//     const maxVisible = 5
//     let start = Math.max(0, pageIndex - 2)
//     let end = Math.min(totalPages, start + maxVisible)

//     if (end - start < maxVisible) {
//       start = Math.max(0, end - maxVisible)
//     }

//     for (let i = start; i < end; i++) {
//       pages.push(i)
//     }
//     return pages
//   }

//   return (
//     <div className="table-responsive">
//       {/* Top Controls – Export button add kiya */}
//       <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search Bajaj Debit..."
//         />
//         <div className="d-flex align-items-center gap-2">
//           <select
//             className="form-select w-auto"
//             value={pageSize}
//             onChange={e => setPageSize(Number(e.target.value))}
//           >
//             <option value={5}>Show 5</option>
//             <option value={10}>Show 10</option>
//             <option value={20}>Show 20</option>
//             <option value={50}>Show 50</option>
//           </select>

//           <button
//             className="btn btn-soft-primary btn-sm"
//             onClick={handleExportCSV}
//             disabled={loading || tableData.length === 0}
//           >
//             <i className="mdi mdi-download me-1"></i> Export CSV
//           </button>
//         </div>
//       </div>

//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       ) : tableData.length === 0 ? (
//         <div className="text-center py-5 text-muted">
//           <h5>No Bajaj Debit records found for the selected filters</h5>
//         </div>
//       ) : (
//         <>
//           <table className="table table-bordered table-hover">
//             <thead className="table-light">
//               <tr>
//                 <th style={{ width: "50px" }}></th>
//                 <th>Date</th>
//                 <th>Mobile</th>
//                 <th>Opening</th>
//                 <th>Closing</th>
//                 <th>Bajaj Debit</th>
//                 <th>Other Debit</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tableData.map(row => (
//                 <React.Fragment key={row.id}>
//                   <tr>
//                     <td className="text-center">
//                       <button
//                         className="btn btn-sm btn-link p-0 fs-5"
//                         onClick={() => toggleExpand(row.id)}
//                       >
//                         {expandedRows[row.id] ? "▼" : "▶"}
//                       </button>
//                     </td>
//                     <td>{row.date}</td>
//                     <td>{row.mobile}</td>
//                     <td>{formatCurrency(row.opening)}</td>
//                     <td>{formatCurrency(row.closing)}</td>
//                     <td>{formatCurrency(row.bajajDebit)}</td>
//                     <td>{formatCurrency(row.otherDebit)}</td>
//                   </tr>

//                   {expandedRows[row.id] && (
//                     <tr>
//                       <td colSpan={7} className="p-0">
//                         {renderSubTable(row.subTransactions)}
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination */}
//           <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//             <div className="text-muted">
//               Showing {tableData.length} of {totalRecords} entries
//               {totalRecords > 0 && (
//                 <span className="ms-2">
//                   Page {pageIndex + 1} of {totalPages}
//                 </span>
//               )}
//             </div>

//             <nav>
//               <ul className="pagination pagination-sm mb-0">
//                 <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoPrev && fetchData(pageIndex - 1)}
//                     disabled={!canGoPrev}
//                   >
//                     Previous
//                   </button>
//                 </li>

//                 {getPageNumbers().map(pageNum => (
//                   <li
//                     key={pageNum}
//                     className={`page-item ${
//                       pageIndex === pageNum ? "active" : ""
//                     }`}
//                   >
//                     <button
//                       className="page-link"
//                       onClick={() => fetchData(pageNum)}
//                     >
//                       {pageNum + 1}
//                     </button>
//                   </li>
//                 ))}

//                 <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoNext && fetchData(pageIndex + 1)}
//                     disabled={!canGoNext}
//                   >
//                     Next
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </>
//       )}
//     </div>
//   )
// }

// export default BajajDebitTable

// // src/pages/Reports/tables/BajajDebitTable.js
// import React, { useState, useEffect, useRef } from "react"
// import { getCombinedTransactionReport } from "../../../helpers/api_helper"

// const BajajDebitTable = ({ filters }) => {
//   const [expandedRows, setExpandedRows] = useState({})
//   const [tableData, setTableData] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [totalRecords, setTotalRecords] = useState(0)
//   const [pageIndex, setPageIndex] = useState(0)
//   const [pageSize, setPageSize] = useState(5) // ← default 5 kar diya

//   // Cache: key = `${pageIndex}-${pageSize}`, value = { rows: [], timestamp }
//   const cache = useRef(new Map())

//   const getCacheKey = (pIndex, pSize) => `${pIndex}-${pSize}`

//   const fetchData = async (
//     newPageIndex = pageIndex,
//     newPageSize = pageSize,
//     forceRefresh = false
//   ) => {
//     const key = getCacheKey(newPageIndex, newPageSize)

//     // Cache hit → turant data show kar do
//     if (!forceRefresh && cache.current.has(key)) {
//       const cached = cache.current.get(key)
//       setTableData(cached.rows)
//       setPageIndex(newPageIndex)
//       setPageSize(newPageSize)
//       setLoading(false)
//       return
//     }

//     setLoading(true)
//     const offset = newPageIndex * newPageSize

//     try {
//       const res = await getCombinedTransactionReport({
//         limit: newPageSize,
//         offset,
//         startDate: filters?.startDate || null,
//         endDate: filters?.endDate || null,
//         mobileNumber:
//           filters?.mobileNumbers?.length > 0 ? filters.mobileNumbers : null,
//       })

//       console.log("Bajaj Debit API Response:", res)

//       if (!res.success || !res.data) {
//         setTableData([])
//         setTotalRecords(0)
//         cache.current.delete(key)
//         return
//       }

//       setTotalRecords(res.totalRecords || 0)

//       let rows = []

//       Object.entries(res.data || {}).forEach(([date, mobiles]) => {
//         Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
//           const openingClosing = categories.opening_closing || {}

//           const bajaj599 = categories.bajaj_599_debit?.total?.amount || 0
//           const bajaj699 = categories.bajaj_699_debit?.total?.amount || 0
//           const bajajOther = categories.bajaj_other_debit?.total?.amount || 0
//           const bajajDebitTotal = bajaj599 + bajaj699 + bajajOther

//           const otherDebit = categories.other_debit?.total?.amount || 0

//           const bajaj599Details = categories.bajaj_599_debit?.details || []
//           const bajaj699Details = categories.bajaj_699_debit?.details || []
//           const bajajOtherDetails = categories.bajaj_other_debit?.details || []
//           const otherDebitDetails = categories.other_debit?.details || []

//           const subTransactions = [
//             ...bajaj599Details.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Bajaj Debit 599",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//             ...bajaj699Details.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Bajaj Debit 699",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//             ...bajajOtherDetails.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Bajaj Other Debit",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//             ...otherDebitDetails.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Other Debit",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//           ]

//           rows.push({
//             id: `${date}-${mobile}`,
//             date: date.trim(),
//             mobile: mobile.trim(),
//             opening: openingClosing.opening || 0,
//             closing: openingClosing.closing || 0,
//             bajajDebit: bajajDebitTotal,
//             otherDebit: otherDebit,
//             subTransactions,
//           })
//         })
//       })

//       rows.sort((a, b) => new Date(b.date) - new Date(a.date))

//       // Cache mein save kar do
//       cache.current.set(key, { rows, timestamp: Date.now() })

//       setTableData(rows)
//       setPageIndex(newPageIndex)
//       setPageSize(newPageSize)
//     } catch (err) {
//       console.error("Bajaj Debit fetch error:", err)
//       setTableData([])
//       setTotalRecords(0)
//       cache.current.delete(key)
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchData(0, pageSize)
//   }, [filters, pageSize])

//   const formatCurrency = val => `₹${Number(val || 0).toLocaleString("en-IN")}`

//   const toggleExpand = id => {
//     setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }))
//   }

//   const renderSubTable = (subTransactions = []) => (
//     <div className="bg-light p-4 border-top">
//       <h6 className="mb-3 fw-semibold">Transaction Details</h6>
//       <div className="table-responsive">
//         <table className="table table-bordered table-sm mb-0">
//           <thead className="table-light">
//             <tr>
//               <th>Date Time</th>
//               <th>Type</th>
//               <th>Amount</th>
//               <th>Transaction ID</th>
//             </tr>
//           </thead>
//           <tbody>
//             {subTransactions.length > 0 ? (
//               subTransactions.map((sub, idx) => (
//                 <tr key={idx}>
//                   <td>{sub.dateTime || "N/A"}</td>
//                   <td>{sub.type || "N/A"}</td>
//                   <td>{formatCurrency(sub.amount)}</td>
//                   <td>{sub.transactionId || "N/A"}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={4} className="text-center text-muted py-3">
//                   No detailed debit transactions available in this report
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   )

//   const handleExportCSV = () => {
//     if (loading || tableData.length === 0) {
//       alert("No data available to export right now.")
//       return
//     }

//     const dateStr = new Date().toISOString().split("T")[0]
//     const filename = `bajaj-debit-report_${dateStr}.csv`

//     const headers = [
//       "Date (Main)",
//       "Mobile",
//       "Opening",
//       "Closing",
//       "Bajaj Debit (Total)",
//       "Other Debit (Total)",
//       "Transaction Date Time",
//       "Type",
//       "Amount",
//       "Transaction ID",
//     ]

//     const csvRows = [headers.join(",")]

//     tableData.forEach(row => {
//       if (row.subTransactions.length === 0) {
//         const mainValues = [
//           `"${(row.date || "").replace(/"/g, '""')}"`,
//           `"${(row.mobile || "").replace(/"/g, '""')}"`,
//           row.opening || 0,
//           row.closing || 0,
//           row.bajajDebit || 0,
//           row.otherDebit || 0,
//           "",
//           "",
//           "",
//           "",
//         ]
//         csvRows.push(mainValues.join(","))
//       } else {
//         row.subTransactions.forEach(sub => {
//           const values = [
//             `"${(row.date || "").replace(/"/g, '""')}"`,
//             `"${(row.mobile || "").replace(/"/g, '""')}"`,
//             row.opening || 0,
//             row.closing || 0,
//             row.bajajDebit || 0,
//             row.otherDebit || 0,
//             `"${(sub.dateTime || "").replace(/"/g, '""')}"`,
//             `"${(sub.type || "").replace(/"/g, '""')}"`,
//             sub.amount || 0,
//             `"${(sub.transactionId || "").replace(/"/g, '""')}"`,
//           ]
//           csvRows.push(values.join(","))
//         })
//       }
//       csvRows.push(",")
//     })

//     const csvContent = csvRows.join("\n")

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement("a")
//     link.href = url
//     link.setAttribute("download", filename)
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
//   }

//   const totalPages = Math.ceil(totalRecords / pageSize)
//   const canGoPrev = pageIndex > 0
//   const canGoNext = pageIndex < totalPages - 1

//   const getPageNumbers = () => {
//     const pages = []
//     const maxVisible = 5
//     let start = Math.max(0, pageIndex - 2)
//     let end = Math.min(totalPages, start + maxVisible)

//     if (end - start < maxVisible) {
//       start = Math.max(0, end - maxVisible)
//     }

//     for (let i = start; i < end; i++) {
//       pages.push(i)
//     }
//     return pages
//   }

//   return (
//     <div className="table-responsive">
//       <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search Bajaj Debit..."
//         />
//         <div className="d-flex align-items-center gap-2">
//           <select
//             className="form-select w-auto"
//             value={pageSize}
//             onChange={e => setPageSize(Number(e.target.value))}
//           >
//             <option value={5}>Show 5</option>
//             <option value={10}>Show 10</option>
//             <option value={20}>Show 20</option>
//             <option value={50}>Show 50</option>
//           </select>

//           <button
//             className="btn btn-soft-primary btn-sm"
//             onClick={handleExportCSV}
//             disabled={loading || tableData.length === 0}
//           >
//             <i className="mdi mdi-download me-1"></i> Export CSV
//           </button>
//         </div>
//       </div>

//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       ) : tableData.length === 0 ? (
//         <div className="text-center py-5 text-muted">
//           <h5>No Bajaj Debit records found for the selected filters</h5>
//         </div>
//       ) : (
//         <>
//           <table className="table table-bordered table-hover">
//             <thead className="table-light">
//               <tr>
//                 <th style={{ width: "50px" }}></th>
//                 <th>Date</th>
//                 <th>Mobile</th>
//                 <th>Opening</th>
//                 <th>Closing</th>
//                 <th>Bajaj Debit</th>
//                 <th>Other Debit</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tableData.map(row => (
//                 <React.Fragment key={row.id}>
//                   <tr>
//                     <td className="text-center">
//                       <button
//                         className="btn btn-sm btn-link p-0 fs-5"
//                         onClick={() => toggleExpand(row.id)}
//                       >
//                         {expandedRows[row.id] ? "▼" : "▶"}
//                       </button>
//                     </td>
//                     <td>{row.date}</td>
//                     <td>{row.mobile}</td>
//                     <td>{formatCurrency(row.opening)}</td>
//                     <td>{formatCurrency(row.closing)}</td>
//                     <td>{formatCurrency(row.bajajDebit)}</td>
//                     <td>{formatCurrency(row.otherDebit)}</td>
//                   </tr>

//                   {expandedRows[row.id] && (
//                     <tr>
//                       <td colSpan={7} className="p-0">
//                         {renderSubTable(row.subTransactions)}
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>

//           <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//             <div className="text-muted">
//               Showing {tableData.length} of {totalRecords} entries
//               {totalRecords > 0 && (
//                 <span className="ms-2">
//                   Page {pageIndex + 1} of {totalPages}
//                 </span>
//               )}
//             </div>

//             <nav>
//               <ul className="pagination pagination-sm mb-0">
//                 <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoPrev && fetchData(pageIndex - 1)}
//                     disabled={!canGoPrev}
//                   >
//                     Previous
//                   </button>
//                 </li>

//                 {getPageNumbers().map(pageNum => (
//                   <li
//                     key={pageNum}
//                     className={`page-item ${
//                       pageIndex === pageNum ? "active" : ""
//                     }`}
//                   >
//                     <button
//                       className="page-link"
//                       onClick={() => fetchData(pageNum)}
//                     >
//                       {pageNum + 1}
//                     </button>
//                   </li>
//                 ))}

//                 <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoNext && fetchData(pageIndex + 1)}
//                     disabled={!canGoNext}
//                   >
//                     Next
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </>
//       )}
//     </div>
//   )
// }

// export default BajajDebitTable

// src/pages/Reports/tables/BajajDebitTable.js
import React, { useState, useEffect, useRef } from "react"
import { getCombinedTransactionReport } from "../../../helpers/api_helper"

const BajajDebitTable = ({ filters, tabKey, sharedCache }) => {
  const [expandedRows, setExpandedRows] = useState({})
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true)
  const [totalRecords, setTotalRecords] = useState(0)
  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(5)

  const getCacheKey = (pIndex, pSize) => `${tabKey}-${pIndex}-${pSize}`

  const fetchData = async (
    newPageIndex = pageIndex,
    newPageSize = pageSize,
    forceRefresh = false
  ) => {
    const key = getCacheKey(newPageIndex, newPageSize)

    // Cache hit → turant data show kar do (rows + totalRecords dono)
    if (!forceRefresh && sharedCache.current.has(key)) {
      const cached = sharedCache.current.get(key)
      setTableData(cached.rows)
      setTotalRecords(cached.totalRecords) // ← Yeh line add ki – total count bhi wapas set ho jayega
      setPageIndex(newPageIndex)
      setPageSize(newPageSize)
      setLoading(false)
      return
    }

    setLoading(true)
    const offset = newPageIndex * newPageSize

    try {
      const res = await getCombinedTransactionReport({
        limit: newPageSize,
        offset,
        startDate: filters?.startDate || null,
        endDate: filters?.endDate || null,
        mobileNumber:
          filters?.mobileNumbers?.length > 0 ? filters.mobileNumbers : null,
      })

      console.log("Bajaj Debit API Response:", res)

      if (!res.success || !res.data) {
        setTableData([])
        setTotalRecords(0)
        sharedCache.current.delete(key)
        return
      }

      const currentTotal = res.totalRecords || 0
      setTotalRecords(currentTotal)

      let rows = []

      Object.entries(res.data || {}).forEach(([date, mobiles]) => {
        Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
          const openingClosing = categories.opening_closing || {}

          const bajaj599 = categories.bajaj_599_debit?.total?.amount || 0
          const bajaj699 = categories.bajaj_699_debit?.total?.amount || 0
          const bajajOther = categories.bajaj_other_debit?.total?.amount || 0
          const bajajDebitTotal = bajaj599 + bajaj699 + bajajOther

          const otherDebit = categories.other_debit?.total?.amount || 0

          const bajaj599Details = categories.bajaj_599_debit?.details || []
          const bajaj699Details = categories.bajaj_699_debit?.details || []
          const bajajOtherDetails = categories.bajaj_other_debit?.details || []
          const otherDebitDetails = categories.other_debit?.details || []

          const subTransactions = [
            ...bajaj599Details.map(detail => ({
              dateTime: detail.time || "",
              type: "Bajaj Debit 599",
              amount: detail.amount || 0,
              transactionId: detail.transaction_id || "N/A",
            })),
            ...bajaj699Details.map(detail => ({
              dateTime: detail.time || "",
              type: "Bajaj Debit 699",
              amount: detail.amount || 0,
              transactionId: detail.transaction_id || "N/A",
            })),
            ...bajajOtherDetails.map(detail => ({
              dateTime: detail.time || "",
              type: "Bajaj Other Debit",
              amount: detail.amount || 0,
              transactionId: detail.transaction_id || "N/A",
            })),
            ...otherDebitDetails.map(detail => ({
              dateTime: detail.time || "",
              type: "Other Debit",
              amount: detail.amount || 0,
              transactionId: detail.transaction_id || "N/A",
            })),
          ]

          rows.push({
            id: `${date}-${mobile}`,
            date: date.trim(),
            mobile: mobile.trim(),
            opening: openingClosing.opening || 0,
            closing: openingClosing.closing || 0,
            bajajDebit: bajajDebitTotal,
            otherDebit: otherDebit,
            subTransactions,
          })
        })
      })

      rows.sort((a, b) => new Date(b.date) - new Date(a.date))

      // Cache mein totalRecords bhi save kar rahe hain
      sharedCache.current.set(key, {
        rows,
        totalRecords: currentTotal,
        timestamp: Date.now(),
      })

      setTableData(rows)
      setPageIndex(newPageIndex)
      setPageSize(newPageSize)
    } catch (err) {
      console.error("Bajaj Debit fetch error:", err)
      setTableData([])
      setTotalRecords(0)
      sharedCache.current.delete(key)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(0, pageSize)
  }, [filters, pageSize])

  const formatCurrency = val => `₹${Number(val || 0).toLocaleString("en-IN")}`

  const toggleExpand = id => {
    setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }))
  }

  const renderSubTable = (subTransactions = []) => (
    <div className="bg-light p-4 border-top">
      <h6 className="mb-3 fw-semibold">Transaction Details</h6>
      <div className="table-responsive">
        <table className="table table-bordered table-sm mb-0">
          <thead className="table-light">
            <tr>
              <th>Date Time</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Transaction ID</th>
            </tr>
          </thead>
          <tbody>
            {subTransactions.length > 0 ? (
              subTransactions.map((sub, idx) => (
                <tr key={idx}>
                  <td>{sub.dateTime || "N/A"}</td>
                  <td>{sub.type || "N/A"}</td>
                  <td>{formatCurrency(sub.amount)}</td>
                  <td>{sub.transactionId || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center text-muted py-3">
                  No detailed debit transactions available in this report
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )

  const handleExportCSV = () => {
    if (loading || tableData.length === 0) {
      alert("No data available to export right now.")
      return
    }

    const dateStr = new Date().toISOString().split("T")[0]
    const filename = `bajaj-debit-report_${dateStr}.csv`

    const headers = [
      "Date (Main)",
      "Mobile",
      "Opening",
      "Closing",
      "Bajaj Debit (Total)",
      "Other Debit (Total)",
      "Transaction Date Time",
      "Type",
      "Amount",
      "Transaction ID",
    ]

    const csvRows = [headers.join(",")]

    tableData.forEach(row => {
      if (row.subTransactions.length === 0) {
        const mainValues = [
          `"${(row.date || "").replace(/"/g, '""')}"`,
          `"${(row.mobile || "").replace(/"/g, '""')}"`,
          row.opening || 0,
          row.closing || 0,
          row.bajajDebit || 0,
          row.otherDebit || 0,
          "",
          "",
          "",
          "",
        ]
        csvRows.push(mainValues.join(","))
      } else {
        row.subTransactions.forEach(sub => {
          const values = [
            `"${(row.date || "").replace(/"/g, '""')}"`,
            `"${(row.mobile || "").replace(/"/g, '""')}"`,
            row.opening || 0,
            row.closing || 0,
            row.bajajDebit || 0,
            row.otherDebit || 0,
            `"${(sub.dateTime || "").replace(/"/g, '""')}"`,
            `"${(sub.type || "").replace(/"/g, '""')}"`,
            sub.amount || 0,
            `"${(sub.transactionId || "").replace(/"/g, '""')}"`,
          ]
          csvRows.push(values.join(","))
        })
      }
      csvRows.push(",")
    })

    const csvContent = csvRows.join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  const totalPages = Math.ceil(totalRecords / pageSize)
  const canGoPrev = pageIndex > 0
  const canGoNext = pageIndex < totalPages - 1

  const getPageNumbers = () => {
    const pages = []
    const maxVisible = 5
    let start = Math.max(0, pageIndex - 2)
    let end = Math.min(totalPages, start + maxVisible)

    if (end - start < maxVisible) {
      start = Math.max(0, end - maxVisible)
    }

    for (let i = start; i < end; i++) {
      pages.push(i)
    }
    return pages
  }

  return (
    <div className="table-responsive">
      <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
        <input
          type="text"
          className="form-control w-50"
          placeholder="Search Bajaj Debit..."
        />
        <div className="d-flex align-items-center gap-2">
          <select
            className="form-select w-auto"
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            <option value={5}>Show 5</option>
            <option value={10}>Show 10</option>
            <option value={20}>Show 20</option>
            <option value={50}>Show 50</option>
          </select>

          <button
            className="btn btn-soft-primary btn-sm"
            onClick={handleExportCSV}
            disabled={loading || tableData.length === 0}
          >
            <i className="mdi mdi-download me-1"></i> Export CSV
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : tableData.length === 0 ? (
        <div className="text-center py-5 text-muted">
          <h5>No Bajaj Debit records found for the selected filters</h5>
        </div>
      ) : (
        <>
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th style={{ width: "50px" }}></th>
                <th>Date</th>
                <th>Mobile</th>
                <th>Opening</th>
                <th>Closing</th>
                <th>Bajaj Debit</th>
                <th>Other Debit</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map(row => (
                <React.Fragment key={row.id}>
                  <tr>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-link p-0 fs-5"
                        onClick={() => toggleExpand(row.id)}
                      >
                        {expandedRows[row.id] ? "▼" : "▶"}
                      </button>
                    </td>
                    <td>{row.date}</td>
                    <td>{row.mobile}</td>
                    <td>{formatCurrency(row.opening)}</td>
                    <td>{formatCurrency(row.closing)}</td>
                    <td>{formatCurrency(row.bajajDebit)}</td>
                    <td>{formatCurrency(row.otherDebit)}</td>
                  </tr>

                  {expandedRows[row.id] && (
                    <tr>
                      <td colSpan={7} className="p-0">
                        {renderSubTable(row.subTransactions)}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>

          <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div className="text-muted">
              Showing {tableData.length} of {totalRecords} entries
              {totalRecords > 0 && (
                <span className="ms-2">
                  Page {pageIndex + 1} of {totalPages}
                </span>
              )}
            </div>

            <nav>
              <ul className="pagination pagination-sm mb-0">
                <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => canGoPrev && fetchData(pageIndex - 1)}
                    disabled={!canGoPrev}
                  >
                    Previous
                  </button>
                </li>

                {getPageNumbers().map(pageNum => (
                  <li
                    key={pageNum}
                    className={`page-item ${
                      pageIndex === pageNum ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchData(pageNum)}
                    >
                      {pageNum + 1}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => canGoNext && fetchData(pageIndex + 1)}
                    disabled={!canGoNext}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </>
      )}
    </div>
  )
}

export default BajajDebitTable
